import { EligibilitySomeoneSupportsYouScreen } from "@/interactors/EligibilitySomeoneSupportsYouScreen";

export default function SomeoneSupportsYou() {
  return <EligibilitySomeoneSupportsYouScreen />;
}
